// extracted by mini-css-extract-plugin
export default {"cursorOuter":"CustomCursor_cursorOuter__D6-eK","cursorInner":"CustomCursor_cursorInner__zC5xk"};